import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import { ButtonProps } from '@mui/material/Button';

import RequiredLabel from '@ui-elements/RequiredLabel';
import ConditionBox from '@ui-parts/ConditionBox';
import InputValidationErrorTooltip from '@ui-parts/InputValidationErrorTooltip';

import { useTranslation } from 'react-i18next';
import { ValidationError } from '@mytypes';
import { PALETTE } from '~/assets/styles/base';

const Wrapper = styled.div`
  width: 100%;
  background: ${PALETTE.bg.main};
  padding: 12px 40px;
  border: 1px solid #eaf0f5;
`;

const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
`;

const FlexItem = styled(Box)`
  flex-grow: 1;
  margin: 10px 0;
  padding: 0 5px;
`;

const RequiredLabelWrapper = styled.div`
  margin-right: 31px;
`;

type SelectedChoice = string;

type Condition = {
  selectedChoices: SelectedChoice[];
  handleClickAddBtn: ButtonProps['onClick'];
  handleClickEditBtn: ButtonProps['onClick'];
  editable?: boolean;
};

type Props = {
  conditions: {
    age: Condition;
    gender: Condition;
  };
  errors?: {
    age: ValidationError;
    gender: ValidationError;
  };
};
const BasicConditionsArea: React.FC<Props> = ({ conditions, errors = null }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper data-testid="uiParts-BasicConditionsArea">
      <FlexBox>
        <FlexItem>
          <InputValidationErrorTooltip
            error={errors ? errors.gender.invalid : false}
            message={errors ? errors.gender.message : ''}
            placement="bottom-end"
            dataTestId="SurveyPriceBox"
          >
            <FlexBox>
              <RequiredLabelWrapper>
                <RequiredLabel
                  label={t('quotas.conditions.requiredLabel')}
                  color={PALETTE.error.main}
                />
              </RequiredLabelWrapper>
              <ConditionBox
                conditionLabel={t('quotas.conditions.titles.gender')}
                selectedChoices={conditions.gender.selectedChoices}
                name="QuotaGender"
                editable={conditions.gender.editable}
                handleClickAddBtn={conditions.gender.handleClickAddBtn}
                handleClickEditBtn={conditions.gender.handleClickEditBtn}
              />
            </FlexBox>
          </InputValidationErrorTooltip>
        </FlexItem>
        <FlexItem>
          <InputValidationErrorTooltip
            error={errors ? errors.age.invalid : false}
            message={errors ? errors.age.message : ''}
            placement="bottom"
            dataTestId="SurveyPriceBox"
          >
            <div>
              <ConditionBox
                conditionLabel={t('quotas.conditions.titles.age')}
                selectedChoices={conditions.age.selectedChoices}
                name="QuotaAge"
                editable={conditions.age.editable}
                handleClickAddBtn={conditions.age.handleClickAddBtn}
                handleClickEditBtn={conditions.age.handleClickEditBtn}
              />
            </div>
          </InputValidationErrorTooltip>
        </FlexItem>
      </FlexBox>
    </Wrapper>
  );
};

export default BasicConditionsArea;
